import { VIEW, type SetViewSizeAction } from '../actions/viewActions';

function getViewSize(width: number): string {
  if (width <= 767) return 'small';
  if (width <= 991) return 'medium';
  if (width <= 1199) return 'large';
  return 'xLarge';
}

export type ViewState = {
  viewSize: string;
};

export const viewInitialState = {
  viewSize: getViewSize(window.innerWidth),
};

export const viewReducer = (state = viewInitialState, action: SetViewSizeAction) => {
  switch (action.type) {
    case VIEW.SET_VIEW_SIZE: {
      return {
        ...state,
        viewSize: getViewSize(action.windowWidth),
      };
    }

    default: {
      return state;
    }
  }
};
